import Vue from "vue"
import Vuex from "vuex"


Vue.use(Vuex)


const store = new Vuex.Store({
    state: {
        userName:"",
        tags:[],
        checkId:'',
        menus:[],//菜单
        checkMenu:'',//所选菜单
        sickName:'',//疾病或者病症
        activeType:0,
        expandName:[],//推广项目
        expandArr:[],
        patientName:'',
        phone:''

    },
  
    mutations: {
      setMenu(state,menu){
        state.menus = menu;
        state.tags.push(menu[0]);//默认打开第一个标签
        state.checkId = menu[0].id;
        state.checkMenu = menu[0].id;
      },
      setUserName(state,name){
          state.userName = name;
      },
      setTags(state,id){
        let isExist = state.tags.filter(item=>item.id===id).length;
        state.checkId = id;
        let selectMenu ;
        for(let i in state.menus){
          if(state.menus[i].id === id){
              selectMenu = state.menus[i];
          }
        }
        
        if(!isExist){//不存在
            state.tags.push(selectMenu)
        }
        console.log(selectMenu)
      },
      //关闭标签
      closeTags(state,id){
        let idx = state.tags.findIndex(item=>item.id===id);
        state.tags.splice(idx,1);
        if(state.tags.length==0){
            state.checkId = "";
            return ;
        }
        state.checkId = idx===0?state.tags[0].id:state.tags[idx-1].id;
      },
      setCheckId(state,id){
        state.checkId = id;
      },
      setCheckMenu(state,id){
        state.checkMenu = id;
      },
      setSick(state,name){
        state.sickName = name;
      },
      setType(state,type){
        state.activeType = type;
      },
      setExpandName(state,name){
        state.expandName = name;
      },
      setPatient(state,name){
        state.patientName = name
      },
      setPhone(state,name){
        state.phone = name
      }
    },
    getters:{
     getTags(state){
         return state.tags;
     },
     getCheckId(state){
         return state.checkId;
     },
     getCheckMenu(state){
       return state.checkMenu;
     },
     getSick(state){
      return state.sickName;
     },
     getExpandName(state){
      return state.expandName;
     },
     getPatient(state){
      return state.patientName;
     },
     getPhone(state){
      return state.phone;
     }
    },
    actions:{
  
    }
  })
  
  export default store;
  


// WEBPACK FOOTER //
// ./src/store/index.js